import { NotificationSetting, NotificationSettingGroup, ProfileNotificationSetting } from "PFTypes";

import {
  NotificationGroupRow,
  NotificationLeafRow,
  NotificationRow,
  NotificationSettingsFormValues
} from "./notifications_settings_form.types";

export const parseNotificationsSettingsToFormValues = (
  notificationsSettings: NotificationSetting[]
): NotificationSettingsFormValues =>
  notificationsSettings.reduce((acc, setting) => {
    acc[setting.id] = {
      frequency: setting.frequency,
      ...((setting as ProfileNotificationSetting).important !== undefined
        ? { important: (setting as ProfileNotificationSetting).important }
        : {})
    };
    return acc;
  }, {} as NotificationSettingsFormValues);

const toLeafRow = (setting: NotificationSetting): NotificationLeafRow => ({
  rowId: String(setting.id),
  group: null,
  setting,
  childrenTableData: []
});

export const buildNotificationRows = (settings: NotificationSetting[]): NotificationRow[] => {
  const ungrouped: NotificationLeafRow[] = [];
  const groupMap = new Map<NotificationSettingGroup, NotificationSetting[]>();

  settings.forEach((setting) => {
    if (setting.group === null) {
      ungrouped.push(toLeafRow(setting));
    } else {
      const children = groupMap.get(setting.group) ?? [];
      groupMap.set(setting.group, [...children, setting]);
    }
  });

  const grouped: NotificationGroupRow[] = Array.from(groupMap.entries()).map(([group, children]) => ({
    rowId: group,
    group,
    setting: null,
    childrenTableData: children.map(toLeafRow)
  }));

  return [...ungrouped, ...grouped];
};
